(() => {
  function init(container) {
    container.querySelectorAll('[data-mmh-product]').forEach(root => {
      if (root.dataset.productReady) return;
      root.dataset.productReady = 'true';
      const image = root.querySelector('.pdp-main-photo');
      const quantity = root.querySelector('input[name="quantity"]');
      const selector = root.querySelector('[data-product-variants]');
      const add = root.querySelector('[data-product-add]');
      const groups = [...root.querySelectorAll('[data-option-position]')];
      let variants = [], unitPrice = Number(root.dataset.initialPrice) || 0;
      try { variants = JSON.parse(root.querySelector('[data-product-variant-data]')?.textContent || '[]'); } catch {}
      const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:root.dataset.currency || 'USD'}).format(amount / 100);
      function subtotal() {
        const node = root.querySelector('[data-product-subtotal]');
        if (node) node.textContent = Number.isFinite(unitPrice) ? money(unitPrice * Math.max(1,Number(quantity.value) || 1)) : '—';
      }
      function showImage(src, alt) {
        if (!image || image.tagName !== 'IMG' || !src) return;
        image.removeAttribute('srcset'); image.src = src;
        if (alt) image.alt = alt;
        root.querySelectorAll('[data-product-thumbnail]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.src === src)));
      }
      root.querySelectorAll('[data-product-thumbnail]').forEach(button => button.addEventListener('click',()=>showImage(button.dataset.src,button.dataset.alt)));
      root.querySelectorAll('[data-quantity-step]').forEach(button => button.addEventListener('click',()=>{
        quantity.value = Math.max(1,(Number(quantity.value)||1)+Number(button.dataset.quantityStep));
        quantity.dispatchEvent(new Event('change',{bubbles:true}));
      }));
      quantity.addEventListener('input',subtotal);
      quantity.addEventListener('change',()=>{quantity.value=Math.max(1,Math.floor(Number(quantity.value)||1));subtotal();});
      function syncButtons(options) {
        groups.forEach((group,index)=>{
          group.querySelectorAll('[data-option-value]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.optionValue===options[index])));
          group.querySelector('[data-option-current]').textContent=options[index] || '';
        });
      }
      function availability() {
        const selected = groups.map(group=>group.querySelector('[aria-pressed="true"]')?.dataset.optionValue);
        groups.forEach((group,index)=>group.querySelectorAll('[data-option-value]').forEach(button=>{
          const matches=variants.filter(v=>v.options.every((value,i)=>value===(i===index?button.dataset.optionValue:selected[i])));
          const available=matches.some(v=>v.available);
          button.dataset.unavailable=String(!available);
          button.setAttribute('aria-label',button.dataset.optionValue+(available?'':' — '+(matches.length?add.dataset.soldoutLabel:add.dataset.unavailableLabel)));
        }));
      }
      function update() {
        const option=selector?.selectedOptions[0];
        const variant=variants.find(v=>String(v.id)===selector?.value);
        const exists=!!option, available=exists && option.dataset.available==='true';
        root.querySelector('[data-product-price]').textContent=exists?option.dataset.price:'—';
        const compare=root.querySelector('[data-product-compare]');
        compare.hidden=!option?.dataset.compare;compare.textContent=option?.dataset.compare || '';
        add.disabled=!available;
        root.querySelector('[data-product-add-label]').textContent=!exists?add.dataset.unavailableLabel:available?add.dataset.availableLabel:add.dataset.soldoutLabel;
        if(variant){unitPrice=variant.price;syncButtons(variant.options);}else{unitPrice=NaN;}
        showImage(option?.dataset.image);
        subtotal();availability();
        const url=new URL(location.href);
        if(exists)url.searchParams.set('variant',selector.value);else url.searchParams.delete('variant');
        history.replaceState({},'',url);
      }
      if(selector){
        selector.addEventListener('change',update);
        if(variants.length && groups.length){
          root.dataset.optionPicker='true';
          const initial=variants.find(v=>String(v.id)===selector.value);
          if(initial)syncButtons(initial.options);
          groups.forEach(group=>group.querySelectorAll('[data-option-value]').forEach(button=>button.addEventListener('click',()=>{
            group.querySelectorAll('[data-option-value]').forEach(peer=>peer.setAttribute('aria-pressed',String(peer===button)));
            group.querySelector('[data-option-current]').textContent=button.dataset.optionValue;
            const selected=groups.map(g=>g.querySelector('[aria-pressed="true"]')?.dataset.optionValue);
            const match=variants.find(v=>v.options.every((value,i)=>value===selected[i]));
            selector.value=match?String(match.id):'';
            update();
          })));
          availability();
        }
      }
      root.querySelector('[data-product-share]')?.addEventListener('click',async()=>{
        const url=new URL(location.href);url.searchParams.delete('preview_theme_id');
        try{if(navigator.share){await navigator.share({title:document.title,url:url.href});}else{await navigator.clipboard.writeText(url.href);const status=root.querySelector('[data-product-share-status]');status.textContent=status.dataset.copiedLabel;}}catch{}
      });
      subtotal();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
